import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { removeToaster } from './../actions/toasters';

class ToasterMessage extends Component {
  constructor(props) {
    super(props);
    this.hide = this.hide.bind(this);
    this.handleLocalStorgaeClear = this.handleLocalStorgaeClear.bind(this);

    const { autoHideDuration=3000, isAutoHide=false } = props;
    if(isAutoHide) {
      setTimeout(() => {
        this.hide();
      }, autoHideDuration);
    }
  }

  hide() {
    // using jqury fadeout function to hide
    const { removeToaster, id } = this.props;
    removeToaster(id);
  }

  handleLocalStorgaeClear() {
    localStorage.clear();
    this.hide();
    location.reload();
  }

  getToasterClassName() {
    const { type = 'error' } = this.props;
    switch (type) {
      case 'success':
        return 'toaster-success';
      case 'warning':
        return 'toaster-warning';
      case 'info':
        return 'toaster-info';
      case 'error':
        return 'toaster-danger';
      default:
        return 'toaster-danger';
    }
  }

  renderToasterByType() {
    const { message, showClose=true } = this.props;
    return (
      <div ref={(el) => { this.toasterWrap = el; }}
           className={`${this.getToasterClassName()} panel animated bounceInUp`}>
        <div>{message}</div>
        {
          showClose && <a role="button" className="close-it pull-right" onClick={this.hide}>&times;</a>
        }
      </div>
    );
  }

  renderAppUpdateToaster() {
    return (
      <div ref={(el) => { this.toasterWrap = el; }}
           className="toaster-danger panel non-dismiss animated bounceInUp">
        <div>Important updates have been made. To make sure you don't experience any issues, please <a href="#" onClick={() => {location.reload();}}>refresh page now</a>.
        </div>
      </div>
    );
  }

  renderLocalStorageFullToaster() {
    return (
      <div ref={(el) => { this.toasterWrap = el; }}
           className="toaster-danger panel non-dismiss animated bounceInUp">
        <div>Not enough storage is available to complete this operation, please <a href="#" onClick={this.handleLocalStorgaeClear}>clear storage now</a>.
        </div>
      </div>
    );
  }

  render() {
    const { type } = this.props;
    if(type === 'toaster-app-update') {
      return this.renderAppUpdateToaster();
    }else if(type === 'local-storage-full'){
      return this.renderLocalStorageFullToaster();
    } else {
      return this.renderToasterByType();
    }
  }

}

ToasterMessage.propTypes = {
  id: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  showClose: PropTypes.bool,
  isAutoHide: PropTypes.bool,
  autoHideDuration: PropTypes.number,
  removeToaster: PropTypes.func,
  type: PropTypes.string, // this is toastr type = error, success, warning, info
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ removeToaster }, dispatch);
};

export default connect(undefined, mapDispatchToProps)(ToasterMessage);



// WEBPACK FOOTER //
// ./src/containers/ToasterMessage.js